import React from "react";
import PropTypes from "prop-types";

// import router link
import { Link } from "react-router-dom";

// import store
import { connect } from "react-redux";

// import store actions
import {
  setAppTokenAsked,
  setAppTokenRetrieved,
  setFormation,
  setOpportunity,
  togglePreloader,
} from "../../store/actions";
import SocialShare from "../../components/common/SocialShare";
// import deep-equal
import equal from "deep-equal";

// import moment
import moment from "moment";
import "moment/locale/fr";

// import services
import {
  getOpportunities,
  getOpportunity,
} from "../../services/opportunityService";
import { getFormations } from "../../services/formationService";

// import dummies
import { COUNTRY, OPPORTUNITY } from "../../helpers/dummies";

// import common components
import Banner from "../../components/common/Banner";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import Square from "../../components/common/Square";
import Image from "../../assets/images/opportunity-Image.png";
import opportunityBanner from "../../assets/images/singleOpportunity-banner.png";
import bannerIcon1 from "../../assets/images/banner-icon1.png";
import bannerIcon2 from "../../assets/images/banner-icon2.png";
import bannerIcon3 from "../../assets/images/banner-icon3.png";
import bannerIcon4 from "../../assets/images/banner-icon4.png";
import Advertisement from "../../assets/images/Advertisement.png";
import AdvertismentSecond from "../../assets/images/advertisment-second.png";
import AdvertismentThird from "../../assets/images/advertisment-third.png";
import Facebook from "../../assets/images/articles/facebook.svg";
import web from "../../assets/images/articles/web.svg";
import mouse from "../../assets/images/mouse-pointer.svg";
import vector from "../../assets/images/Vector.svg";
import share from "../../assets/images/share.svg";
import flag from "../../assets/images/flagIcon.svg";
import thumb from "../../assets/images/Group.svg";
import Icon from "../../assets/images/opportunity-Icon.png";
import profile from "../../assets/images/articles/userProfile.png";
import Book from "../../assets/images/Book.svg";
import Profile from "../../assets/images/articles/userProfile.png";
import pinterest from "../../assets/images/articles/pinterest.svg";
import social from "../../assets/images/articles/social.svg";
import CommonIcon from "../../components/common/CommonIcon";
// import constants
import {
  BOURSES_100,
  BOURSES_50,
  APP_TOKEN,
  USER_DATA,
} from "../../helpers/constants";

// import utilities
import {
  // getObjectByKey,
  slugify,
  isUnauthenticatedRequest,
} from "../../helpers/utilities";

class Opportunity extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
       nextLink: "#", 
       prevLink: "#", 
       showLoginLink: false ,
       isShareModalOpen: false,
      };
  }

  componentDidMount() {
    try {
      // Load opportunity

      //Get props
      let { onPreloaderToggled, location } = this.props;

      if (!localStorage.getItem(USER_DATA)) {
        //Check school status
        this.setState({ showLoginLink: true });
        this.onGetOpportunity();
      } else {
        //Start preloader
        this.props.onPreloaderToggled(true, "Chargement de l'opportunité");

        // Load school
        this.onGetOpportunity();
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  componentDidUpdate(prevProps) {
    try {
      //Check props
      if (!equal(prevProps, this.props)) {
        if (this.props.tokenRetrieved && localStorage.getItem(APP_TOKEN)) {
          this.props.onAppTokenRetrieved(false);
          this.onGetOpportunity();
        } else if (this.props.tokenFailed) {
          this.onGetOpportunity();
          this.props.onPreloaderToggled(false, "");
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  componentWillUnmount() {
    this.props.onSetOpportunities({});
  }

  handleShareModalOpen = () => {
    this.setState({
      isShareModalOpen: true,
    });
  };

  handleShareModalClose = () => {
    this.setState({
      isShareModalOpen: false,
    });
  };

  /**
   * Get opportunity.
   *
   */
  onGetOpportunity() {
    let { onPreloaderToggled, onAppTokenAsked, location } = this.props;
    let { code } = location.state;
    // let code = "HNtDZ8Jkkq";
    // console.log({ code });
    getOpportunity(code)
      .then((response) => {
        if (response && response.publicId && response.publicId === code) {
          this.props.onSetOpportunities({
            ...response,
            category: response.category ? response.category : "Bourse",
            image: response.image ? response.image : OPPORTUNITY.image,
            officialLink: response.officialLink
              ? response.officialLink
              : OPPORTUNITY.officialLink,
            country: response.country ? response.country : COUNTRY,
            city: response.city ? response.city : OPPORTUNITY.city,
            medias: response.medias ? response.medias : OPPORTUNITY.medias,
          });
          // this.onGetOpportunities();
        } else if (isUnauthenticatedRequest(response)) {
          this.props.onAppTokenAsked(true);
        } else {
          console.error(response, "GET OPPORTUNITY ERROR");
        }
      })
      .catch((error) => {
        console.error(error, "GET OPPORTUNITY ERROR");
      });
  }

  /**
   * Get opportunities.
   *
   */
  onGetOpportunities() {
    getOpportunities()
      .then((response) => {
        if (response && response.data) {
          let opportunites = response.data.map((ox) => ({
            ...ox,
            image: ox.image ? ox.image : OPPORTUNITY.image,
          }));
          this.props.onSetOpportunities(opportunites);
          this.onGetFormations();
        } else if (isUnauthenticatedRequest(response)) {
          this.props.onAppTokenAsked(true);
        } else {
          console.error(response, "GET OPPORTUNITIES ERROR");
        }
      })
      .catch((error) => {
        console.error(error, "GET OPPORTUNITIES ERROR");
      });
  }

  /**
   * Get formations.
   *
   */

  // onClick(){
  //   console.log("working")
  // }

  onGetFormations() {
    getFormations()
      .then((response) => {
        if (response && response.data) {
          this.props.onSetFormations(response.data);
          this.props.onPreloaderToggled(false, "");
        } else if (isUnauthenticatedRequest(response)) {
          this.props.onAppTokenAsked(true);
        } else {
          this.props.onPreloaderToggled(false, "");
          console.error(response, "GET FORMATIONS ERROR");
        }
      })
      .catch((error) => {
        this.props.onPreloaderToggled(false, "");
        console.error(error, "GET FORMATIONS ERROR");
      });
  }

  render() {
    const { opportunity, isPreloader } = this.props;
    const { nextLink, prevLink, showLoginLink,isShareModalOpen } = this.state;

    return (
      <React.Fragment>
        <>
          {/* <div
            id="opportunitiy"
            className={`${isPreloader ? "d-none" : "d-block"}`}
          > */}
          <div>
            <section className="opportunite-home ">
              <div className="container pt-16">
                <div className="col-lg-12">
                  <div className="flex justify-between mb-3 mt-2">
                    <Breadcrumbs
                      subtitle="Opportunités"
                      subtitleLink="/opportunites"
                      // extratitle="Home"
                      extratitleLink="/"
                      currentTile={opportunity.name}
                    />
                    <CommonIcon />
                  </div>
                  {/* <Breadcrumbs
                  subtitle="opportunities"
                  subtitleLink="/opportunites"
                  extratitle={opportunity.category}
                  extratitleLink="#"
                  currentTile={opportunity.name}
                /> */}
                </div>
                <div className="opportunite-bg">
                  <div className="opportunit-div">
                    <div className="opportunit-title">
                      <div className="top-title">
                        <p>Catégorie et/ou sous-cat</p>
                        <p>
                          {opportunity?.city} .{" "}
                          <span>
                            {opportunity?.country?.continent}{" "}
                            <a href="">
                              <img src={flag} alt="" />
                            </a>
                          </span>
                        </p>
                      </div>
                      <h1>
                        {opportunity.name}
                        <br></br>(2024-2025)
                      </h1>
                    </div>
                    <div className="opportunit-icon-div">
                      <div className="opportunit-icon-div-top">
                        <span>Partager</span>
                        {/* <a href="">
                          <img src={share} alt="" />
                        </a> */}
                         <button
                         type="button"
                        onClick={this.handleShareModalOpen}
                          >
                       <img src={share} alt="share icon" />
                        </button>
                        <SocialShare
                        opened={isShareModalOpen}
                        onClosed={this.handleShareModalClose}
                        shareLink={`https://dev.aceorientation.com/formations/${slugify(
                                        opportunity?.name
                          )}`}
                          />
                      </div>
                      <div className="opportunit-icon-div-top">
                        <span>Suivre</span>
                        <a href="">
                          <img src={thumb} alt="" />
                        </a>
                      </div>
                      <div className="opportunit-icon-div-top">
                        <span>Postuler</span>
                        <a href="">
                          <img src={mouse} alt="" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="opportunite-home-image">
                    <img src={opportunityBanner} alt="" />
                  </div>
                </div>
              </div>
            </section>
            <section className="Avantages">
              <div className="container">
                <div className="Avantages-bg">
                  <h2>Avantages de la bourse</h2>
                  <div className="Avantages-icon">
                    <div className="Avantages-icon-div">
                      <img src={bannerIcon1} alt="" />
                      <p>Bourse complète</p>
                    </div>
                    <div className="Avantages-icon-div">
                      <img src={bannerIcon1} alt="" />
                      <p>Bourse partielle</p>
                    </div>
                    <div className="Avantages-icon-div">
                      <img src={bannerIcon2} alt="" />
                      <p>Multi-années</p>
                    </div>
                    <div className="Avantages-icon-div">
                      <img src={Book} alt="" />
                      <p>Voyage</p>
                    </div>
                    <div className="Avantages-icon-div">
                      <img src={bannerIcon4} alt="" />
                      <p>Cours de langue</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="description">
              <div className="container">
                <div className="row">
                  <div className="col-lg-7">
                    <h2>Description</h2>
                    <div class="accordion accordion-dark" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            Description du programme
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            {opportunity?.description}
                            {/* Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. */}
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            Avantages de la bourse
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            {opportunity?.advantages}
                            {/* Quisque sapien augue, ornare id leo a, tristique
                          elementum justo. */}
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Conditions d’éligibilité des candidat.e.s
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            {opportunity?.conditions}
                          </div>
                        </div>
                      </div>
                    </div>
                    <h2>Procédure de candidature</h2>
                    <div className="accordion accordion-dark" id="accordionExample">
                      {opportunity && opportunity.application ? (
                        opportunity.application?.map((item, index) => (
                          <div className="accordion-item" key={item.id}>
                            <h2
                              className="accordion-header"
                              id={`heading${item.id}`}
                            >
                              <button
                                className={`accordion-button ${
                                  item.id === "collapseOne"
                                    ? "show"
                                    : "collapsed"
                                }`}
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#${item.id}`}
                                aria-expanded={item.id === "collapseOne"}
                                aria-controls={item.id}
                              >
                                step{index + 1}
                              </button>
                            </h2>
                            <div
                              id={item.id}
                              className={`accordion-collapse collapse ${
                                item.id === "collapseOne" ? "show" : ""
                              }`}
                              aria-labelledby={`heading${item.id}`}
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body">
                                {item.status}
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <></>
                      )}
                    </div>
                    <h2>FAQs</h2>
                    <div class="accordion accordion-dark" id="accordionExample">
                      {opportunity && opportunity.faqs ? (
                        opportunity.faqs.map((item, index) => (
                          <div className="accordion-item" key={item.id}>
                            <h2
                              className="accordion-header"
                              id={`heading${item.id}`}
                            >
                              <button
                                className={`accordion-button ${
                                  item.id === "collapseOne"
                                    ? "show"
                                    : "collapsed"
                                }`}
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#${item.id}`}
                                aria-expanded={item.id === "collapseOne"}
                                aria-controls={item.id}
                              >
                                step{index + 1}
                              </button>
                            </h2>
                            <div
                              id={item.id}
                              className={`accordion-collapse collapse ${
                                item.id === "collapseOne" ? "show" : ""
                              }`}
                              aria-labelledby={`heading${item.id}`}
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body">
                                {item.response}
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-4 offset-1">
                    <div className="blog">
                      <div className="blog-image">
                        <img src={profile} alt="" />
                      </div>
                      <div className="blog-content-div">
                        <h5>By Luise S.Rudrigo</h5>
                        <p>Lorem ipsum dolor sit amet consectetur</p>
                        <div className="blog-icon">
                          <img src={Facebook} alt="" />
                          <img src={social} alt="" />
                          <img src={pinterest} alt="" />
                          <img src={web} alt="" />
                        </div>
                        <a href="#">Voir plus de cet auteur</a>
                      </div>
                    </div>
                    <div className="Publicité">
                      <p>Publicité</p>
                      <img src={AdvertismentThird} alt="" />
                    </div>
                    <div className="Publicité">
                      <p>Publicité</p>
                      <img src={Advertisement} alt="" />
                    </div>
                    <div className="Publicité">
                      <p>Publicité</p>
                      <img src={AdvertismentSecond} alt="" />
                    </div>
                    <div className="Publicité">
                      <p>Publicité</p>
                      <img src={Advertisement} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      </React.Fragment>
    );
  }
}
Opportunity.propTypes = {
  opportunity: PropTypes.object,
  onSetOpportunity: PropTypes.func,
  onSetFormations: PropTypes.func,
  isPreloader: PropTypes.bool,
  tokenFailed: PropTypes.bool,
  tokenRetrieved: PropTypes.bool,
  onAppTokenAsked: PropTypes.func,
  onAppTokenRetrieved: PropTypes.func,
  onPreloaderToggled: PropTypes.func,
};
const mapStateToProps = (state) => ({
  opportunity: state.opportunity,
  opportunities: state.opportunities,
  formations: state.formations,
  tokenRetrieved: state.tokenRetrieved,
  tokenFailed: state.tokenFailed,
  isPreloader: state.isPreloader,
});
const mapDispatchToProps = (dispatch) => ({
  onSetOpportunity: (data) => dispatch(setOpportunity(data)),
  onSetOpportunities: (data) => dispatch(setOpportunity(data)),
  onSetFormations: (data) => dispatch(setFormation(data)),
  onAppTokenAsked: (data) => dispatch(setAppTokenAsked(data)),
  onAppTokenRetrieved: (data) => dispatch(setAppTokenRetrieved(data)),
  onPreloaderToggled: (preload, message) =>
    dispatch(togglePreloader(preload, message)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Opportunity);
